var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobGammaShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d8400;\n      }\n\n      .cls-2 {\n        fill: #35202f;\n      }\n\n      .cls-3 {\n        fill: #1fa000;\n      }\n\n      .cls-4 {\n        fill: #301d29;\n      }\n\n      .cls-5 {\n        fill: #261722;\n      }\n\n      .cls-6 {\n        fill: #3f2738;\n      }\n\n      .cls-7 {\n        fill: #5b4956;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "614.26 364.53 574.52 370.49 491.83 370.49 491.83 300.11 614.26 318.5 614.26 364.53"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "573.82 332.32 401.26 240.99 72.27 326.76 2.19 373.09 298.91 388.36 542.82 411.32 573.82 332.32"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "542.82 411.32 34.81 396.13 2.19 373.09 552.82 386.32 542.82 411.32"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "482.61 486.08 168.82 456.32 144.05 437.09 483.61 464.6 482.61 486.08"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "231.03 420.3 59.8 410.48 59.8 403.46 231.03 393.64 231.03 420.3"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "482.88 464.6 143.32 437.09 85.33 372.56 484.85 375.94 482.88 464.6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "484.82 376.32 482.82 464.32 420.82 458.32 410.82 375.32 484.82 376.32"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "573.82 332.32 552.82 245.32 470.82 220.32 71.82 326.32 463.82 273.32 573.82 332.32"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "483.82 464.32 482.82 486.32 426.82 480.32 420.82 458.32 483.82 464.32"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "463.82 273.32 71.82 326.32 1.82 373.32 463.82 273.32"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "573.82 332.32 462.82 273.32 470.82 220.32 644.82 263.32 573.82 332.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobGammaShip);
export default __webpack_public_path__ + "static/media/mob-gamma-ship.608793af17e9bd95ed5e18d0e22e6f21.svg";
export { ForwardRef as ReactComponent };